'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurfHeight = function SurfHeight(_ref) {
  var min = _ref.min,
      max = _ref.max,
      units = _ref.units,
      _ref$plus = _ref.plus,
      plus = _ref$plus === undefined ? false : _ref$plus;

  var isFlat = !min && !max || units === 'FT' && min < 1 && max <= 1 || units === 'M' && min < 0.3 && max <= 0.3;
  var className = (0, _classnames2.default)({
    'quiver-surf-height': true,
    'quiver-surf-height--flat': isFlat
  });

  if (isFlat) {
    return _react2.default.createElement(
      'span',
      { className: className },
      'Flat'
    );
  }

  var range = min === max ? max : min + '-' + max;

  return _react2.default.createElement(
    'span',
    { className: className },
    range,
    _react2.default.createElement(
      'sup',
      null,
      units
    ),
    plus ? '+' : ''
  );
};

SurfHeight.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  units: _propTypes2.default.string,
  plus: _propTypes2.default.bool
};

exports.default = SurfHeight;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurfHeight/SurfHeight.js
// module id = 664
// module chunks = 11